const reportAttributionStatisticModule = {
  state: {
    items: null,
  },
  mutations: {
    setAttributionStatistic (state, data) {
      state.items = data
    },
  },
  getters: {
    getAttributionStatistic: (state) => {
      return state.items
    },
  }
}

export default reportAttributionStatisticModule



// WEBPACK FOOTER //
// ./src/store/modules/report_attribution_statistic.js